import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ApiServiceShared {
  addUserSource = new BehaviorSubject<string>("false");
  addUser$ = this.addUserSource.asObservable();

  private resultSource = new Subject<string>();
  result$ = this.resultSource.asObservable();

  constructor() {
    this.addUser$.subscribe(status => window.localStorage.setItem("addUser", status));
  }

  updateLocalStorage(): Observable<any> {
    let userStatus = window.localStorage.getItem("addUser");
    userStatus = userStatus === "false" || userStatus == null ? "true" : "false";
    this.addUserSource.next(userStatus);
    return this.addUser$;
  }

  setResult(result: string) {
    this.resultSource.next(result);
  }
}
